module.exports = __webpack_public_path__ + "static/media/YM85_3.6ec7b0b9.jpg";